import React, { Component, Fragment } from 'react';

import {
  TextField,
  FormHelperText
} from '@material-ui/core';

import { withStyles } from '@material-ui/styles';

import StripeInput from '../components/StripeInput';
import { commonStyles } from '../styles';

const styles = theme => ({
  textField: {
    ...commonStyles(theme).textField,
    '& .StripeElement': {
      width: '100%'
    }
  }
});

class StripeElementWrapper extends Component {
  state = {
    focused: false,
    empty: true,
    error: false
  };

  handleChange = changeObj => {
    const { setComplete } = this.props;
    const { empty, error, complete, elementType } = changeObj;

    this.setState({
      empty,
      error
    });

    setComplete(elementType, complete);
  }

  handleFocus = () => this.setState({focused: true})
  handleBlur = () => this.setState({focused: false})

  render() {
    const { focused, empty, error } = this.state;
    const { classes, label, autoComplete, component } = this.props;

    return (
      <Fragment>
        <TextField
          className={classes.textField}
          label={label}
          fullWidth
          autoComplete={autoComplete}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          InputProps={{
            inputProps: {component},
            inputComponent: StripeInput
          }}
          InputLabelProps={{shrink: focused || !empty}}
        />
        {error ? (
          <FormHelperText error>{error.message}</FormHelperText>
        ) : null}
      </Fragment>
    );
  }
}

export default withStyles(styles)(StripeElementWrapper);